import { ETIFormData, QuestionFormData } from '../types';

type NormalizedFormData = Omit<ETIFormData, 'taskId' | 'status'>;

const parseOptions = (
  optionsRaw: unknown,
  fallback: QuestionFormData['options'],
): string[] | undefined => {
  if (typeof optionsRaw === 'string' && optionsRaw.trim().length > 0) {
    try {
      const parsed = JSON.parse(optionsRaw);
      if (Array.isArray(parsed)) {
        return parsed.map(v => String(v));
      }
    } catch (err) {
      console.error('Failed to parse optionsRaw', err);
    }
  } else if (Array.isArray(fallback)) {
    return fallback;
  }
  return undefined;
};

const parseFilter = (
  filterRaw: unknown,
  fallback: QuestionFormData['filter'],
): QuestionFormData['filter'] | undefined => {
  if (typeof filterRaw === 'string' && filterRaw.trim().length > 0) {
    try {
      const parsed = JSON.parse(filterRaw);
      if (parsed && typeof parsed === 'object') {
        return parsed as QuestionFormData['filter'];
      }
    } catch (err) {
      console.error('Failed to parse filterRaw', err);
    }
  } else if (fallback && typeof fallback === 'object') {
    return fallback;
  }
  return undefined;
};

export const normalizeQuestionsForSubmit = (
  formData: NormalizedFormData,
): NormalizedFormData => ({
  ...formData,
  questions: formData.questions.map(q => {
    const { optionsRaw, filterRaw, options, filter, ...rest } =
      q as QuestionFormData & { optionsRaw?: string; filterRaw?: string };
    const parsedOptions = parseOptions(optionsRaw, options);
    const parsedFilter = parseFilter(filterRaw, filter);
    const result: QuestionFormData = { ...rest } as QuestionFormData;
    if (parsedOptions !== undefined) result.options = parsedOptions;
    if (parsedFilter !== undefined) result.filter = parsedFilter;
    return result;
  }),
});
